import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSectionAnimated from '../Components/HeroSection';
import WhyJoinSection from '../Components/WhyJoinSection';
import RightForYouSection from '../Components/RightForYouSection';
import HowItWorksSection from '../Components/HowItWorksSection';
import BenefitsSection from '../Components/BenefitsSection';
import LevelsSection from '../Components/LevelsSection';
import LeaderboardSection from '../Components/LeaderboardSection';
import ActiveChallengesSection from '../Components/ActiveChallengesSection';
import TestimonialsSection from '../Components/TestimonialsSection';
import JoinCommunitySection from '../Components/JoinCommunitySection';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Lunor.Quest | Crowdsourcing AI Innovation Made Easy</title>
        <meta 
          name="description" 
          content="Join Lunor.Quest to crowdsource solutions at every step of the AI pipeline. Whether you're an individual or an organization, launch quests to solve real-world challenges and unlock groundbreaking results."
        />
      </Helmet>
      <div className="relative font-lexend">
        {/* Hero Section with glow effect */}
        <div className="h-screen bg-black relative overflow-hidden">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#FBCD40] via-black to-black opacity-[0.15]" />
          <HeroSectionAnimated 
            text="Collaborate to build the future of AI"
            subtext="Solve real-world problems and earn rewards while advancing your career"
          />
        </div>

        {/* Other sections without glow */}
        <div className={`relative isolate font-lexend space-y-24 bg-white dark:bg-black`}>
          <WhyJoinSection />
          <RightForYouSection />
          <HowItWorksSection />
          <BenefitsSection />
          <LevelsSection />
          <LeaderboardSection />
          <ActiveChallengesSection />
          <TestimonialsSection />
          <JoinCommunitySection />
        </div>
      </div>
    </>
  );
};

export default Home; 